var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": "編輯團購數量",
      "centered": "",
      "cancel-title": "取消編輯",
      "cancel-variant": "danger",
      "ok-title": "確認送出",
      "ok-variant": "success"
    },
    on: {
      "ok": _vm.handleSubmit
    },
    model: {
      value: _vm.showQuantity,
      callback: function callback($$v) {
        _vm.showQuantity = $$v;
      },
      expression: "showQuantity"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Line 暱稱：" + _vm._s(_vm.data.customer_name))]), _c('div', [_vm._v("下單組數：" + _vm._s(_vm.data.quantity))]), _c('div', [_vm._v("單價：$" + _vm._s(_vm.round(_vm.data.price)))]), _c('div', [_vm._v("金額：$" + _vm._s(_vm.round(_vm.data.total_price)))]), _c('b-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inline-form-custom-select-pref"
    }
  }, [_vm._v("請輸入新的組數：")]), _c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 qty-input",
    attrs: {
      "type": "number",
      "min": _vm.groupbuying.once_quantity || 1,
      "max": _vm.groupbuying.once_max_quantity || 10,
      "step": _vm.groupbuying.once_increase_quantity || 1
    },
    on: {
      "change": _vm.handleInput
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = _vm._n($$v);
      },
      expression: "quantity"
    }
  })], 1), _c('div', [_vm._v("總金額：$" + _vm._s(_vm.totalPrice))])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }